<template>
  <div class="timeline-card-wrapper">
    <el-collapse :value="cardKey">
      <el-collapse-item :name="cardKey">
        <template slot="title">
          <div class="timeline-card-title">
            <slot name="title">
              {{ title }}
            </slot>
          </div>
        </template>
        <div
          v-for="item in items"
          :key="item.expoMeetingCode"
          class="timeline-items-wrapper"
        >
          <div class="timeline-items-card">
            <div class="timeline-card-tail-wrapper">
              <div class="timeline-card-tail">
                <div class="dot start">
                  <i class="fa fa-bullseye" />
                </div>
                <div class="dot end" v-if="item.meetingEndTime">
                  <i class="fa fa-bullseye" />
                </div>
              </div>
              <div class="timeline-card-tail-context">
                <div class="start-time">
                  {{
                    showType == 'A'
                      ? item.meetingBeginTime
                      : item.meetingLocalBeginTime
                  }}
                </div>
                <div class="my-2">
                  <el-tag
                    size="mini"
                    :type="
                      item.expoMeetingStatus === 'Y'
                        ? 'Y'
                        : item.expoMeetingStatus === 'E'
                        ? 'success'
                        : item.expoMeetingStatus === 'D'
                        ? 'danger'
                        : ''
                    "
                  >
                    {{ item.v_expoMeetingStatus }}
                  </el-tag>
                </div>
                <TextLabel
                  :label="
                    showType == 'A'
                      ? $l('list_label_localTime') || 'Local Time'
                      : item.v_meetingTimeZone
                  "
                  label-bold
                  :value-bold="false"
                >
                  <span>
                    {{
                      showType == 'A' ? item.meetingLocalDate : item.meetingDate
                    }}
                    {{
                      showType == 'A'
                        ? item.meetingLocalBeginTime
                        : item.meetingBeginTime
                    }}
                  </span>
                </TextLabel>
                <div class="end-time" v-if="item.meetingEndTime">
                  {{
                    showType == 'A'
                      ? item.meetingEndTime
                      : item.meetingLocalEndTime
                  }}
                </div>
              </div>
            </div>
            <div class="timeline-items-card-context">
              <el-row :gutter="10">
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="$l('list_label_custName') || 'Customer name'"
                        :value="item.custName"
                      />
                    </el-col>
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="
                          $l('list_label_purposeOrIssue') || 'Purpose or Issue'
                        "
                        :value="item.purposeOrIssue"
                      />
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col class="mt-3">
                      <TextLabel
                        :label="
                          $l('list_label_productCategories') ||
                            'Product categories'
                        "
                        :value="item.productCategories"
                      />
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <el-row :gutter="10">
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col class="mt-3">
                      <TextLabel
                        :label="
                          $l('list_label_customerName') || 'Customer name'
                        "
                        :value="item.customerName"
                      />
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="$l('list_label_keyContact') || 'Key contact'"
                        :value="item.keyContact"
                      />
                    </el-col>
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="$l('list_label_meetingAddres') || 'Address'"
                        :value="item.meetingAddres"
                      />
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <el-row :gutter="10">
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="
                          $l('list_label_attendanceNameList') ||
                            'ABS attendance'
                        "
                        :value="convertsArrayString(item.attendanceNameList)"
                      />
                    </el-col>
                    <el-col :md="12" class="mt-3">
                      <TextLabel
                        :label="
                          $l('list_label_merchandiserNameList') ||
                            'Merchandiser'
                        "
                        :value="convertsArrayString(item.merchandiserNameList)"
                      />
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :lg="12">
                  <el-row :gutter="10">
                    <el-col :md="8" class="mt-3">
                      <TextLabel
                        :label="$l('list_label_meetingLocation') || 'Location'"
                        :value="item.meetingLocation"
                      />
                    </el-col>
                    <el-col :md="16" class="mt-3 opts-col">
                      <TextLabel>
                        <template #label>
                          <div><br /></div>
                        </template>
                        <slot name="opts" :item="item" />
                      </TextLabel>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div class="timeline-items-opts">
              <slot name="menus" :item="item" />
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import TextLabel from './label.vue'
export default {
  components: { TextLabel },
  props: {
    cardKey: { type: String, default: '1' },
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    showType: { type: String, default: '' },
  },
  methods: {
    convertsArrayString(str) {
      if (!str) return ''
      const data = JSON.parse(str)
      return data.join(' / ')
    },
  },
}
</script>
<style lang="scss" scoped>
.timeline-card-wrapper {
  background-color: #f8f8f9;
  border-radius: 6px;
}
.timeline-card-title {
  color: #6c757d;
  font-size: 15px;
}

::v-deep {
  .el-collapse,
  .el-collapse-item__header,
  .el-collapse-item__wrap {
    border: none;
  }
  .el-collapse-item__header,
  .el-collapse-item__wrap {
    background-color: transparent;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .el-collapse-item__header {
    --height: auto;
    height: var(--height);
    line-height: var(--height);
    padding: 10px 18px;
  }
  .el-collapse-item__arrow {
    margin: 0 0 0 auto;
  }
}
</style>
<style lang="scss" scoped>
.timeline-items-wrapper {
  padding: 0 18px 16px;
  position: relative;
  .timeline-items-card {
    background-color: #ffffff;
    border-radius: 6px;
    padding: 10px;
    display: flex;
  }
  .timeline-card-tail-wrapper {
    width: 130px;
    padding: 3px 4px 3px 20px;
    .timeline-card-tail {
      --top: 0px;
      --bottom: 0px;
      position: absolute;
      left: calc(16px + 20px);
      top: var(--top);
      bottom: var(--bottom);
      height: calc(100% - var(--top) - var(--bottom));
      border-left: 2px solid #e4e7ed;
      .dot {
        --color: black;
        position: absolute;
        left: -9px;
        --dot-top: 0;
        --dot-bottom: 0;
        background-color: #ffffff;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        .fa {
          color: var(--color);
          font-size: 16px;
        }
      }
      .dot.start {
        --color: #007bff;
        top: var(--dot-top);
      }
      .dot.end {
        --color: #fa561f;
        bottom: var(--dot-bottom);
      }
    }
    .timeline-card-tail-context {
      height: 100%;
      padding-bottom: 24px;
      position: relative;
      .end-time {
        position: absolute;
        bottom: 0;
      }
    }
  }
  .timeline-items-card-context {
    flex: 1;
    .el-col {
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
    }
  }
  .timeline-items-opts {
    position: absolute;
    top: 10px;
    right: 30px;
  }
}
.timeline-card-wrapper .timeline-items-wrapper:first-child {
  .timeline-card-tail {
    --top: 18px;
  }
}
.timeline-card-wrapper .timeline-items-wrapper:last-child {
  .timeline-card-tail {
    --bottom: 34px;
  }
}
.timeline-card-wrapper .timeline-items-wrapper:not(:first-child) {
  .timeline-card-tail .dot.start {
    --dot-top: 18px;
  }
}
.timeline-card-wrapper .timeline-items-wrapper:not(:last-child) {
  .timeline-card-tail .dot.end {
    --dot-bottom: 34px;
  }
}
</style>
<style lang="scss" scoped>
::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
}
</style>
